module.exports = __webpack_public_path__ + "img/_3.f563d50d.png";